
import React, { useRef, useState } from "react"
import { useMsal } from "@azure/msal-react";
import { useLocation} from 'react-router-dom';
import { InteractionStatus } from "@azure/msal-browser";

//internal imports
import {useSkidsWithConfig, useSkidsWithConfigDispatch, Skid} from '../AvailableSkids/skidsWithConfigProvider'
import SelectForm from '../Select/SelectForm';
import { isPopulated, toSelectOptions, mapToSelectOptions } from '../AvailableSkids/skidsHelpers';
import { Box } from "@mui/material";
import {useTracker, useTrackerDispatch} from '../FetchTracker/FetchTrackerProvider'
import { fetchAvailableSkidsWithConfigHeaders,fetchBaseline, authenticatedFetch, fetchBaselines, fetchTresholds} from '../../Helper/Fetch/fetch';
import { loginRequest, protectedResources } from "../../authConfig";
import BaselineConfig from './baselineConfig';
import TresholdConfig from "./tresholdConfig";
import TresholdConfigAdd from "./tresholdConfigAdd";



interface LocationState{
    targetSkid: string
}
export type Baseline = {
    Tag:string
    MedianCalculatedValue:number
    CalibratedCalculatedValue:number
    CalibratedValue:number
    CalibrationTime:string
}
export type Treshold = {
    Id:string
    Tag:string
    Value:number
    Type:string 
    Period:number
    Ratio:number
}
function RheoAdviseConfig(){
    const { instance, inProgress,accounts } = useMsal();
    const request = {scopes: protectedResources.whoami.scopes,account: accounts[0]}
    const locationState = useLocation().state as LocationState;
    var targetSkid:string= ''
    if(locationState){
        const navigationSkid = locationState.targetSkid
        if (navigationSkid){
            targetSkid = navigationSkid
        }
    }

    const [skid, setSkid] = useState(targetSkid)
    const [baselines, setBaselines] = useState<Baseline[]>([])
    const [tresholds, setTresholds] = useState<Treshold[]>([])
    const [calibration, setCalibration] = useState<number>(0)
    const [medianBaseline, setMedianBaseline] = useState<number>(0)
    const [lastCalibration, setLastCalibration] = useState<string>('') //only for display purpose, so just keep as string
    const skidsWithConfig = useSkidsWithConfig()
    const skidsWithConfigDispatch = useSkidsWithConfigDispatch()
    const Tracker = useTracker()
    const TrackerDispatch = useTrackerDispatch()
    const baselineFetched = useRef(false)
    const tresholdsFetched = useRef(false)
    
    function handleSkidChange(event:React.ChangeEvent<HTMLInputElement>){
        setSkid(event.target.value)
        baselineFetched.current=false
        tresholdsFetched.current=false
        setBaselines([])     
    }
    function handleTresholdDelete(treshold:Treshold){
        console.log('handling treshold delete for treshold:',treshold)
        setTresholds(tresholds.filter((t)=>t.Id !== treshold.Id))
    }
        
    
    
    if(baselineFetched.current === false && isPopulated(skidsWithConfig) && skid){
        console.log('fetching baseline for skid:',skidsWithConfig.get(skid).name)
        baselineFetched.current=true
        fetchBaselines(request, instance, skidsWithConfig.get(skid).name).
        then((res=>res.json())).
        then((res)=>{
            console.log('baseline res:',res)
            const newBaselines:Baseline[] = Object.values(res)
            console.log('new baselines:',newBaselines)
            setBaselines(newBaselines)
           /*  var rawMedian = res.MedianCalculatedValue
            var rawCalibrated = res.CalibratedCalculatedValue
            console.log('raw median:',rawMedian,'raw calibrated:',rawCalibrated)
            baselineFetched.current=true
            setMedianBaseline(parseFloat(rawMedian))
            setCalibration(parseFloat(rawCalibrated))
            setLastCalibration(res.CalibrationTime) */
            
        })
    }
    if(tresholdsFetched.current === false && isPopulated(skidsWithConfig) && skid){
        console.log('fetching tresholds for skid:',skidsWithConfig.get(skid).name)
        tresholdsFetched.current=true
        fetchTresholds(request, instance, skidsWithConfig.get(skid).name).
        then((res=>res.json())).
        then((res)=>{
            console.log('tresholds res:',res)
            const newTresholds:Treshold[] = Object.values(res)
            console.log('new tresholds:',newTresholds)
            setTresholds(newTresholds)
        })
    }
     if(isPopulated(skidsWithConfig)===false && Tracker.skidsWithConfig===false){
                console.log('No Skids Available with config, and no previous fetch, starting refetch')
                if (inProgress ===InteractionStatus.None ){
                    fetchAvailableSkidsWithConfigHeaders(request, instance).
                    then((res => res.json()))
                    .then((items)=>{
                      
                        console.log("dispatching:",items)
                        skidsWithConfigDispatch({type:'addSkidsWithConfig',skids:items})
                        
                    })
                    TrackerDispatch({type:'skidsWithConfig',value:true})
                    //fetch here
                    
                    //dispatch tracker here
                    //dispatch skids here
                }
        
            }
    return(
        <Box className="Viewbox" sx={{display:'flex', flexDirection:'column', alignItems:'center', mt:5}}>
        <Box sx={{display:'flex', flexDirection:'column', alignItems:'center', mt:5}}>
        <SelectForm 
            title='Selected Skid' 
            options={mapToSelectOptions(skidsWithConfig)} 
            selected={skid} 
            changeHandler={handleSkidChange} 
           
        />
        </Box>
        <Box sx={{display:'flex', flexDirection:'column', alignItems:'center', mt:5}}>
        
        <Box >
        <h3 style={{color:'whitesmoke'}}>Baselines for {skid}</h3>
        {skid && !skidsWithConfig.get(skid).supervisor && <p style={{color:'whitesmoke'}} color="white" >You do not have the required rigths to set calibration baselines for {skidsWithConfig.get(skid).name}</p>}
        {skid && baselines.length > 0 &&
            Array.from(baselines).map((baseline)=><BaselineConfig key={baseline.Tag} skid={skid} baseline={baseline} skidsWithConfig={skidsWithConfig}/>)
        }
        </Box>
        <Box sx={{mt:5}}>
        <h3 style={{color:'whitesmoke'}}>Tresholds for {skid}</h3>
        {skid && tresholds.length > 0 &&
            Array.from(tresholds).map((treshold)=><TresholdConfig key={treshold.Id} skid={skid} treshold={treshold} skidsWithConfig={skidsWithConfig} deleteHandler={handleTresholdDelete}/>)
        }
        </Box >
        <Box sx={{mt:5}}>
        <h3 style={{color:'whitesmoke'}}>Add Treshold for {skid}</h3>
        {skid && <TresholdConfigAdd skid={skid} setTreshold={(newTreshold:Treshold)=>setTresholds([...tresholds, newTreshold])} skidsWithConfig={skidsWithConfig}/>}
        </Box>
        </Box> 
        </Box>)
}
export default RheoAdviseConfig